import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { createChangePasswordSchema } from "../schema/change-password.schema";
import type { ChangePasswordForm } from "../types";

const useChangePassword = () => {
	const { t } = useTranslation();
	const schema = createChangePasswordSchema({
		oldPasswordRequired: t("psdaCommon.profile.changePassword.validations.oldPasswordRequired"),
		passwordRequired: t("psdaCommon.auth.resetPassword.validations.passwordRequired"),
		minPasssword: t("psdaCommon.auth.resetPassword.validations.minPasssword"),
		maxPasssword: t("psdaCommon.auth.resetPassword.validations.maxPasssword"),
		confirmPasswordRequired: t("psdaCommon.auth.resetPassword.validations.confirmPasswordRequired"),
		passwordMismatch: t("psdaCommon.auth.resetPassword.validations.passwordMismatch"),
		confirmMinPasssword: t("psdaCommon.auth.resetPassword.validations.confirmMinPasssword"),
		confirmMaxPasssword: t("psdaCommon.auth.resetPassword.validations.confirmMaxPasssword"),
		lowerLetter: t("psdaCommon.auth.resetPassword.validations.lowerLetter"),
		upperLetter: t("psdaCommon.auth.resetPassword.validations.upperLetter"),
		aNumber: t("psdaCommon.auth.resetPassword.validations.aNumber"),
		specialCharcter: t("psdaCommon.auth.resetPassword.validations.specialCharcter"),
		weakPassword: t("psdaCommon.auth.resetPassword.validations.weakPassword"),
	});

	const methods = useForm<ChangePasswordForm>({
		resolver: zodResolver(schema),
		mode: "onTouched",
		defaultValues: {
			oldPassword: "",
			newPassword: "",
			confirmPassword: "",
		},
	});

	return { methods };
};

export default useChangePassword;
